import { render, staticRenderFns } from "./NeoAvatar.vue?vue&type=template&id=4fdf8b60&scoped=true&"
import script from "./NeoAvatar.vue?vue&type=script&lang=js&"
export * from "./NeoAvatar.vue?vue&type=script&lang=js&"
import style0 from "./NeoAvatar.vue?vue&type=style&index=0&id=4fdf8b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdf8b60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
